<template>
  <section id="generator" class="container">
    <div class="header">
      <span class="category">{{ t('generator_category') }}</span>
      <h2>{{ t('generator_input_h2') }}</h2>
      <p>{{ t('generator_input_p') }}</p>
    </div>

    <form @submit.prevent class="box__shadow column highlight__extra">
      <Input
        :value="generator.email"
        :required="true"
        :errorMsg="generator.inputError"
        placeholder="generator_input_placeholder"
        label="generator_input_label"
        @update="generator.email = $event"
        class="input__wrapper"
      />

      <Textarea
        class="input__wrapper"
        :value="generator.description"
        :required="true"
        placeholder="generator_textarea_placeholder"
        label="generator_textarea_label"
        @update="generator.description = $event"
      />

      <Submit
        @click="generateEmail"
        :loading="generator.loading"
        :disabled="generator.disabled"
        text="Create"
        class="submit__btn"
      />
    </form>
  </section>
</template>

<script>
import { reactive, computed, nextTick } from 'vue'
import { useStore } from 'vuex'

import Input from '@components/input/Input.vue'
import Textarea from '@components/input/Textarea.vue'
import Submit from '@components/button/Submit.vue'

export default {
  name: 'GenerateForm',
  components: { Input, Textarea, Submit },
  setup() {
    const store = useStore()
    const generatedMails = computed(() => store.getters.getGeneratedMails)
    const generator = reactive({
      email: '',
      description: '',
      disabled: false,
      loading: false,
      inputError: '',
    })

    const generateEmail = async () => {
      if (generatedMails.value >= 3) return store.commit('setToastMessage', 'max_amount_error')
      if (generator.email === '' || generator.description === '') return

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailRegex.test(generator.email)) return (generator.inputError = 'invalid_email')
      else generator.inputError = ''

      generator.loading = true
      generator.disabled = true

      const generated = await store.dispatch('generateEmail', {
        recipient: generator.email,
        productDescription: generator.description,
        options: {
          language: store.state.language,
          tone: 'casual',
          length: 'short',
        },
      })

      generator.loading = false
      generator.disabled = false

      if (generated) {
        nextTick(() => {
          const element = document.getElementById('generator__result')
          if (element) element.scrollIntoView({ behavior: 'smooth' })
        })

        await store.dispatch('updateMailsGeneratedToday')
      }
    }

    return {
      generator,
      generateEmail,
    }
  },
}
</script>

<style lang="scss" scoped>
#generator {
  form {
    margin: 0 auto;
    border-radius: 7px;
    padding: 30px;
    width: 500px;
    max-width: calc(90% - 30px);
    justify-content: flex-end;

    @media only screen and (max-width: 450px) {
      padding: 15px;
    }

    .input__wrapper {
      margin-bottom: 10px;
    }
  }
}
</style>
